document.addEventListener("DOMContentLoaded", function () {
  const cartProductsContainer = document.getElementById("cart-products");
  const cartSubtotalElement = document.getElementById("cart-subtotal");
  const cartItemsCount = document.querySelectorAll(".cart-items-count");
  const checkoutButton = document.getElementById("checkout-button");
  const cartSpinner = document.querySelector(".cart-drawer__loader");
  const atcButton = document.querySelector("#atc-btn");
  const homeProductActionButtons = document.querySelectorAll(".atc-js button");
  const pdpFeaturedAtc = document.querySelectorAll(".atc-pdp-js");
const currentUrl = window.location.pathname;
  //PDP product form atc
  atcButton?.addEventListener("click", function () {
    const activeAction = document.querySelector(".product-action-main.active");
    if (!activeAction) {
      console.error("No active action found");
      return;
    }

    const productType = activeAction.getAttribute("data-product-type");
    const variantId = this.getAttribute("data-variant-id");
    const sellingPlanId =
      productType === "subscription"
        ? this.getAttribute("data-selling-plan")
        : null;
    
    if ((variantId === '45457370546406' || variantId === '45457376149734') && productType === 'one-time') {
      if(currentUrl.includes('/pages/acne-serum')){
        
      $('body').addClass('popup-open');
      $('#phylaUpsellOverlay').addClass('active');
      // return;
      }else{
        
      $('body').addClass('popup-open');
      $('#phylaUpsellOverlay').addClass('active');
      return;
      }
    }
    
    const atcSpinner = this.querySelector(".loading__spinner");
    if (productType === "subscription") {
      
      addToCart(variantId, sellingPlanId, atcSpinner);
    } else {
      
      addToCart(variantId, null, atcSpinner);
    }
  });

  $('.product-action-main').on('click', function () {
    const subscriptionType = $(this).data('product-type');
    const $dropdown = $(this).closest('.rd-system-purchase-dropdown');
    if ($dropdown.length) {
      if (subscriptionType == "subscription") {
        $dropdown.find('.pdp-dropdown-price--subscription').show();
        $dropdown.find('.pdp-dropdown-price--one-time').hide();
      } else {
        $dropdown.find('.pdp-dropdown-price--subscription').hide();
        $dropdown.find('.pdp-dropdown-price--one-time').show();
      }
    }
  });
  // PDP subscription upsell popup
  $('#phylaUpsellOverlay').on('click', '.phyla-subscribe-continue', function() {
    let $atc = $('#atc-btn');
    let variantId = $atc.attr('data-variant-id');
    let atcSpinner = $(".loading__spinner")[0];

    addToCart(variantId, null, atcSpinner);
    $('body').removeClass('popup-open');
    $('#phylaUpsellOverlay').removeClass('active');
  })

  // PDP custom upsell popup close
  $('#phylaUpsellOverlay').on('click', '.popup-close', function(event) {
    let $atc = $('#atc-btn');
    let variantId = $atc.attr('data-variant-id');
    let atcSpinner = $(".loading__spinner")[0];

    addToCart(variantId, null, atcSpinner);
    $('body').removeClass('popup-open');
    $('#phylaUpsellOverlay').removeClass('active');
  })

  $('#phylaUpsellOverlay').on('click', '.phyla-subscribe-confirm', function() {
    let $atc = $('#atc-btn');
    let variantId = $atc.attr('data-variant-id');
    let sellingPlanId = $atc.attr('data-selling-plan');
    let atcSpinner = $(".loading__spinner")[0];

    addToCart(variantId, sellingPlanId, atcSpinner);
    $('body').removeClass('popup-open');
    $('#phylaUpsellOverlay').removeClass('active');
  })

  // homepage products atc
  homeProductActionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const sellingPlanId = this.getAttribute("data-selling-plan");
      const atcSpinner = this.querySelector(".loading__spinner");
      addToCart(variantId, sellingPlanId, atcSpinner);
    });
  });
  // PDP featured products atc
  pdpFeaturedAtc.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const sellingPlanId = this.getAttribute("data-selling-plan");
      addToCart(variantId, sellingPlanId);
    });
  });
  function showSpinner(elem) {
    elem?.classList.remove("hidden");
  }
  function hideSpinner(elem) {
    elem?.classList.add("hidden");
  }
  function fetchCart(option = null, atcSpinner = null) {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        option == "open" && openCartDrawer();
        atcSpinner && hideSpinner(atcSpinner);
        renderCartItems(cart);
        $('.non-accordion').removeClass('op-6')
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  function addToCart(
    variantId,
    sellingPlanId = null,
    atcSpinner = null,
    quantity = 1
  ) {
    showSpinner(atcSpinner);
    $('.non-accordion').addClass('op-6')
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlanId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        fetchCart("open", atcSpinner);
        return response.json();
      })
      .catch((error) => {
        console.error("Error adding item to cart:", error);
        hideSpinner(atcSpinner);
        alert("There was an issue updating your cart. Please try again!");
      });
  }

  function renderCartItems(cart) {
    if (cart.item_count > 0) {
      $(".cart-bottom").removeClass("empty-cart-footer");
      $(".main-cart-manage").removeClass("empty-cart-top");
    } else {
      $(".cart-bottom").addClass("empty-cart-footer");
      $(".main-cart-manage").addClass("empty-cart-top");
    }

    const fragment = document.createDocumentFragment();
    cartProductsContainer.innerHTML = "";

    cart.items.forEach((item, index) => {
      const cartItemHTML = createCartItemHTML(item, index + 1);
      const div = document.createElement("div");
      div.innerHTML = cartItemHTML;
      fragment.appendChild(div);
    });

    cartProductsContainer.appendChild(fragment);
    updateCartSubtotal(cart);
    updateCartCount(cart);
    hideSpinner(cartSpinner);
    attachQuantityListeners();
  }

  function createCartItemHTML(item, index) {
    return `
    <div class="cart-product" data-id="${item.id}">
        <div class="cart-product-img">
            <a href="${item.url}" class="product-link">
                <img src="${
                  item.image
                }" class="img-fluid" alt="${item.product_title}">
            </a>
        </div>
        <div class="cart-product-about">
            <div class="cart-product-title">
                <a href="${item.url}" class="product-link">
                    <p>${item.vendor}</p>
                    <h3>${item.product_title}</h3>
                </a>
                ${
                  item.selling_plan_allocation
                    ? `
                    <p>Delivery Every 2 Months</p>
                `
                    : ""
                }
            </div>
            <div class="cart-qty-price">
                <div class="cart-qty">
                    <button class="icon-qty" data-action="decrease" data-id="${
                      item.id
                    }"  data-line="${index}">
                        <img src="https://cdn.shopify.com/s/files/1/0568/7368/1095/files/minus-icon.svg?v=1730292011" class="img-fluid">
                    </button>
                    <div class="qty-input">
                        <input type="number" value="${
                          item.quantity
                        }" min="0" data-id="${item.id}"  data-line="${index}">
                    </div>
                    <button class="icon-qty" data-action="increase" data-id="${
                      item.id
                    }"  data-line="${index}">
                        <img src="https://cdn.shopify.com/s/files/1/0568/7368/1095/files/plus-icon.svg?v=1730292011" class="img-fluid">
                    </button>
                </div>
                <div class="cart-product-price">
${
  item.selling_plan_allocation &&
  item.selling_plan_allocation.compare_at_price > item.price
    ? `
  <p class="off-price">$${
    item.selling_plan_allocation.compare_at_price / 100
  }</p>
  <p>$${item.price / 100}</p>
`
    : `
  <p>$${item.price / 100}</p>
`
}

                </div>
            </div>
        </div>
        <button class="remove-cart-item" onclick="removeItem('${item.key}')">
            <img src="https://cdn.shopify.com/s/files/1/0568/7368/1095/files/fill-cross.svg?v=1730292011" class="img-fluid">
        </button>
    </div>`;
  }

  function attachQuantityListeners() {
    const quantityButtons = document.querySelectorAll(".icon-qty");

    quantityButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const action = this.getAttribute("data-action");
        const productId = this.getAttribute("data-id");
        const line = this.getAttribute("data-line");
        const cartItem = document.querySelector(
          `.cart-product[data-id="${productId}"]`
        );
        const inputField = cartItem.querySelector('input[type="number"]');
        let newQuantity = parseInt(inputField.value);

        if (action === "increase") {
          newQuantity += 1;
        } else if (action === "decrease") {
          newQuantity = Math.max(0, newQuantity - 1);
        }

        inputField.value = newQuantity;
        updateItem(line, newQuantity);
      });
    });

    const quantityInputs = document.querySelectorAll(
      '.qty-input input[type="number"]'
    );

    quantityInputs.forEach((input) => {
      input.addEventListener("change", function () {
        const line = this.getAttribute("data-line");
        const newQuantity = parseInt(this.value);
        updateItem(line, newQuantity);

        // if (newQuantity < 0) {
        //   this.value = 1;
        //   updateItem(line, 1);
        // } else {
        //   updateItem(line, newQuantity);
        // }
      });
    });
  }

  function updateCartSubtotal(cart) {
    const total = (cart.total_price / 100).toFixed(2);
    cartSubtotalElement.innerText = `$${total}`;
  }

  window.openCartDrawer = function () {
    function isCartHidden() {
      $("body").hasClass("show-cart");
    }

    if (!isCartHidden()) {
      $("body").addClass("show-cart");
    }
  };

  function updateCartCount(cart) {
    cartItemsCount.forEach((item) => {
      item.innerText = `${cart.item_count}`;
    });
  }

  window.removeItem = function (key) {
    showSpinner(cartSpinner);
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then((response) => response.json())
      .then((cartData) => {
        renderCartItems(cartData);
      })

      .catch((error) => {
        console.error("Error removing item:", error);
        alert("There was an issue updating your cart. Please try again!");
      });
  };

  window.updateItem = function (line, quantity) {
    showSpinner(cartSpinner);
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ line: line, quantity: parseInt(quantity) }),
    })
      .then((response) => response.json())
      .then((cartData) => {
        renderCartItems(cartData);
      })
      .catch((error) => {
        console.error("Error updating item:", error);
        alert("There was an issue updating your cart. Please try again!");
      });
  };
  checkoutButton.addEventListener("click", function () {
    window.location.href = "/checkout";
  });
  fetchCart();
});
